import React from 'react';

const FeaturesBenefits: React.FC = () => {
    // Hide scrollbar while keeping scroll functionality
    React.useEffect(() => {
        const style = document.createElement('style');
        style.textContent = `
            .features-scroll::-webkit-scrollbar {
                display: none;
            }
            .features-scroll {
                -ms-overflow-style: none;
                scrollbar-width: none;
            }
        `;
        document.head.appendChild(style);
        return () => {
            document.head.removeChild(style);
        };
    }, []);

    const benefits = [
        {
            number: '1',
            title: 'Transparency',
            description: 'Upload your resume or job description'
        },
        {
            number: '2',
            title: 'Scalable',
            description: 'Works for startups and enterprises alike'
        },
        {
            number: '3',
            title: 'AI-Powered',
            description: 'Recruiting that adapts and improves'
        },
        {
            number: '4',
            title: 'Less Effort',
            description: 'No endless applications'
        }
    ];

    return (
        <section className="relative px-4 py-8 sm:py-10 lg:py-12">
            <div className="container mx-auto max-w-[1640px]">
                {/* Section Title */}
                <h2
                    className="text-left mb-6 sm:mb-8 lg:mb-10"
                    style={{
                        fontFamily: 'Manrope',
                        fontStyle: 'normal',
                        fontWeight: 700,
                        fontSize: 'clamp(32px, 6vw, 72px)',
                        lineHeight: 'clamp(40px, 7vw, 90px)',
                        letterSpacing: '-0.05em',
                        color: '#FFFFFF',
                        maxWidth: '100%',
                    }}
                >
                    Built for modern recruiting
                </h2>

                {/* Cards Container */}
                <div
                    className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6"
                    style={{
                        maxWidth: '100%',
                    }}
                >
                    {benefits.map((benefit, index) => (
                        <div
                            key={index}
                            className="w-full"
                            style={{
                                boxSizing: 'border-box',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                padding: 'clamp(16px, 4vw, 32px) clamp(12px, 3vw, 24px)',
                                gap: 'clamp(12px, 3vw, 20px)',
                                minHeight: 'clamp(200px, 40vw, 280px)',
                                background: 'rgba(20, 30, 48, 0.6)',
                                border: '1px solid rgba(255, 255, 255, 0.1)',
                                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.3)',
                                backdropFilter: 'blur(20px)',
                                borderRadius: 'clamp(16px, 4vw, 24px)',
                            }}
                        >
                            {/* Number Circle */}
                            <div
                                style={{
                                    position: 'relative',
                                    width: 'clamp(50px, 12vw, 80px)',
                                    height: 'clamp(60px, 15vw, 93px)',
                                    flex: 'none',
                                    order: 0,
                                    flexGrow: 0,
                                }}
                            >
                                {/* Blue Circle Background */}
                                <div
                                    style={{
                                        position: 'absolute',
                                        left: '50%',
                                        top: '5%',
                                        transform: 'translateX(-50%)',
                                        width: 'clamp(45px, 10vw, 70px)',
                                        height: 'clamp(45px, 10vw, 70px)',
                                        background: '#015FA6',
                                        borderRadius: '50%',
                                    }}
                                />
                                {/* Number */}
                                <span
                                    style={{
                                        position: 'absolute',
                                        width: '100%',
                                        height: 'clamp(45px, 12vw, 75px)',
                                        left: '0px',
                                        top: 'clamp(12px, 3vw, 18px)',
                                        fontFamily: 'Manrope',
                                        fontStyle: 'normal',
                                        fontWeight: 500,
                                        fontSize: 'clamp(50px, 15vw, 100px)',
                                        lineHeight: 'clamp(45px, 12vw, 75px)',
                                        letterSpacing: '-0.02em',
                                        color: '#FFFFFF',
                                        textAlign: 'center',
                                        zIndex: 1,
                                    }}
                                >
                                    {benefit.number}
                                </span>
                            </div>

                            {/* Title */}
                            <h3
                                style={{
                                    width: '100%',
                                    fontFamily: 'Manrope',
                                    fontWeight: 600,
                                    fontSize: 'clamp(14px, 3.5vw, 20px)',
                                    lineHeight: 'clamp(20px, 4.5vw, 28px)',
                                    textAlign: 'center',
                                    letterSpacing: '-0.01em',
                                    color: '#FFFFFF',
                                    margin: 0,
                                }}
                            >
                                {benefit.title}
                            </h3>

                            {/* Description */}
                            <p
                                style={{
                                    width: '100%',
                                    fontFamily: 'Manrope',
                                    fontWeight: 400,
                                    fontSize: 'clamp(11px, 2.5vw, 14px)',
                                    lineHeight: 'clamp(16px, 3.5vw, 20px)',
                                    textAlign: 'center',
                                    letterSpacing: '0em',
                                    color: 'rgba(255, 255, 255, 0.7)',
                                    margin: 0,
                                }}
                            >
                                {benefit.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FeaturesBenefits;
